import styles from './styles.module.scss'

const AiThinkingIndicator = ({ size = 24, speed = 2 }) => {
  return (
    <div className={styles.aiThinkingWrapper}>
      <div className={styles.loader} style={{ '--size': `${size}px`, '--speed': `${speed}s` }}>
        <span className={styles.loader__inner}></span>
        <span className={styles.loader__inner}></span>
      </div>
    </div>
  )
}

export default AiThinkingIndicator
